import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { useContext } from 'react';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { NetworkDisplaySkeleton } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/NetworkDisplaySkeleton';
import { ContentLayout } from 'app/agriculture/components/ContentLayout/ContentLayout';

export function NetworkDisplay() {
    return (
        <SuspenseWrapper loadingComponent={<NetworkDisplaySkeleton />}>
            <WrappedNetworkDisplay />
        </SuspenseWrapper>
    );
}

function WrappedNetworkDisplay() {
    const { device } = useContext(DeviceDetailContext);
    const {
        timestamp,
        macAddress,
        dataRate,
        frequency,
        latency,
        txPower,
        rssi,
        ipV6Addresses,
        networkAddresses,
        secondaryNetworkAddresses,
        peerMacAddresses,
    } =
        useSnapshot({
            snapshotType: 'Network',
            parentId: device.id,
            shelfLife: { hours: 1 },
        }) ?? {};

    return (
        <ContentBox.Section heading="Network Stats" disableDivider timestamp={timestamp}>
            <ContentLayout className="NetworkDisplay">
                <SimpleGrid columns={3}>
                    <StatDisplay name="RSSI" value={rssi} unit="dBm" />
                    <StatDisplay name="Latency" value={latency} unit="ms" />
                    <StatDisplay name="Data Rate" value={dataRate} unit="bit/s" />
                    <StatDisplay name="Frequency" value={frequency} unit="MHz" />
                    <StatDisplay name="Transmission Power" value={txPower} unit="dBm" />
                    <StatDisplay name="Mac Address" value={macAddress} />
                </SimpleGrid>
                <SimpleGrid columns={2}>
                    <StatDisplay
                        name="ipV6 Addresses"
                        value={
                            !ipV6Addresses || ipV6Addresses.length === 0
                                ? null
                                : ipV6Addresses.join(', ')
                        }
                    />
                    <StatDisplay
                        name="Network Addresses"
                        value={
                            !networkAddresses || networkAddresses.length === 0
                                ? null
                                : networkAddresses.join(', ')
                        }
                    />
                    <StatDisplay
                        name="Secondary Network Addresses"
                        value={
                            !secondaryNetworkAddresses || secondaryNetworkAddresses.length === 0
                                ? null
                                : secondaryNetworkAddresses.join(', ')
                        }
                    />
                    <StatDisplay
                        name="Peer Mac Addresses"
                        value={
                            !peerMacAddresses || peerMacAddresses.length === 0
                                ? null
                                : peerMacAddresses.join(', ')
                        }
                    />
                </SimpleGrid>
            </ContentLayout>
        </ContentBox.Section>
    );
}
